// extracted by mini-css-extract-plugin
export var active = "_2f-7";
export var backButton = "_2f-6";
export var clone = "_2f-c";
export var collapseBar = "_2f-h";
export var collapseMode = "_2f-j";
export var dragHandle = "_2f-a";
export var dropdownIcon = "_2f-e";
export var hidden = "_2f-p";
export var iconContainer = "_2f-m";
export var iconSwapper = "_2f-o";
export var navItem = "_2f-4";
export var navItemIcon = "_2f-d";
export var navProfile = "_2f-5";
export var notificationCountBadge = "_2f-g";
export var notificationDot = "_2f-n";
export var optionsContainer = "_2f-f";
export var primaryNav = "_2f-0";
export var primaryTab = "_2f-k";
export var secondaryNav = "_2f-1";
export var selected = "_2f-l";
export var settingsNav = "_2f-2";
export var settingsNavItems = "_2f-3";
export var show = "_2f-b";
export var sideNav = "_2f-i";
export var teamItem = "_2f-8";
export var userProfileItem = "_2f-9";